import {Component, Input} from '@angular/core';
import {Constants} from '../../../constants/constants';

@Component({
  selector: 'app-navigation-header',
  templateUrl: './navigation-header.component.html',
  styleUrls: ['./navigation-header.component.scss']
})
export class NavigationHeaderComponent {
  @Input() selectedRole: string;
  @Input() extraClass: string;

  Constants = Constants;

  get shouldAdjust(): boolean {
    return this.selectedRole === Constants.MANAGER
      || this.selectedRole === Constants.SERVER
      || this.selectedRole === 'Admin'
      || this.selectedRole === Constants.TABLE;
  }
}
